import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const ColibShowcasePage = lazy(() => import('../../pages/ColibShowcasePage'));

// Reachable only from the developer-tools toolbar: the dashboardDef entry sets
// `sidebar.hide`, so there is no nav item. Access is guarded inside the page via
// getEnvironment().isDev (redirects to NOT_FOUND off dev/preview).
const routes = [{ path: Location.COLIB_SHOWCASE, component: ColibShowcasePage, exact: true }];

export default routes;
